/**
 * Validates a post-login redirect target as same-origin path + search only.
 * Used by route loaders and SignIn to mitigate open redirects (CWE-601).
 *
 * @param {string|null|undefined} raw - Path + search, possibly URI-encoded (e.g. from ?redirect=)
 * @param {string} appOrigin - Expected app origin (e.g. `new URL(request.url).origin` or `window.location.origin`)
 * @returns {string|null} Safe `pathname + search` for in-app navigation, or null
 */
export function getSafeInternalRedirectPath(raw, appOrigin) {
  if (raw == null || typeof raw !== "string") return null;

  let decoded;
  try {
    decoded = decodeURIComponent(raw.trim());
  } catch {
    return null;
  }

  if (!decoded || decoded.includes("\0") || decoded.includes("\\")) return null;
  if (decoded.includes("@")) return null;
  if (/^[a-zA-Z][\w+.-]*:/i.test(decoded)) return null;

  let parsed;
  try {
    parsed = new URL(decoded, appOrigin);
  } catch {
    return null;
  }

  if (parsed.origin !== new URL(appOrigin).origin) return null;
  if (parsed.username || parsed.password) return null;

  const out = `${parsed.pathname}${parsed.search}`;
  if (!out.startsWith("/") || out.startsWith("//")) return null;

  return out;
}
